import './WLGN.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class WLGN extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

};
